export default "__VITE_ASSET__DBKjkd5F__"